import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { App } from "../App";
import { BiMath } from "../libs/BiMath";
import { ERC20Contract } from "../contracts/ERC20Contract";
import { Token, WalletControllerBase } from "../controllers/WalletControllerBase";
import { ShareXHelperContract } from "../contracts/ShareXHelperContract";
import { ShareX, ShareXInfrastructure } from "../contracts/ShareXInfrastructure";
import { Helper } from "../libs/Helper";
import { Web3Helper } from "../libs/Web3Helper";
import { ShareXContract } from "../contracts/ShareXContract";

export class CmpWidgetShareXTable extends com.CmpWidgetShareXTableBase {

   
    constructor() {
        super();
         this.ctrls.btnSelect.onclick=async ()=>{
            const shareXCtrl = App.Inst.getInst(ShareXInfrastructure);
            if (!shareXCtrl) return;
            const address = this.ctrls.cmpSearch.ctrls.iSearch.value;
            if (!BiMath.isValidAddress(address))
            {
                App.gui.dialogOkShowAsync("Invalid address");
                return;
            }
            const exist = shareXCtrl.getSharex(address);
            if (exist)
            {
                shareXCtrl.selectShareX(exist);
                return;
            }
            let sharex = new ShareX();
            try
            {
                this.disable();
                const erc20 = new ERC20Contract(address, App.chain.provider);
                sharex.name = await erc20.name();
                if (!sharex.name) throw new Error();
                sharex.symbol = await erc20.symbol();
                if (!sharex.symbol) throw new Error();
                sharex.address = address;
            } catch(e)
            {
                this.enable();
                App.gui.dialogOkShowAsync("Is it ShareX?");
                return;
            }
            shareXCtrl.addSharex(sharex);
            shareXCtrl.selectShareX(sharex);
            this.ctrls.cmpSearch.ctrls.iSearch.value='';
            this.enable();
        }
        this.ctrls.btnConnect.onclick=async ()=>{
            this.ctrls.btnConnect.disable();
            const result = await App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        }
        this.ctrls.btnAll.onclick=()=>{
            if (this._items.length==0) return;
            const needSelect = !this._items[0].isActive;
            for(const i of this._items) 
                if (needSelect) i.active(); else i.inactive();
            this._checkBtnsActive();
        }
        this.ctrls.btnCalc.onclick=async ()=>{await App.gui.awaitInLockUIAsync(this._tryCalcAsync()); this.refreshAsync(true);}
        this.ctrls.btnClaim.onclick=async ()=>{await App.gui.awaitInLockUIAsync(this._tryClaimAsync()); this.refreshAsync(true);}
    }

    private _refreshFunc:any
    public initialize()
    {
        this._refreshFunc=async ()=>{this.refreshAsync()}
        App.chain.onChangeAccount.addHandler(this._refreshFunc);
        const sharexInf = App.Inst.getInst(ShareXInfrastructure);
        if (sharexInf) sharexInf.onRefresh.addHandler(this._refreshFunc);
        this.refreshAsync();
    }
    public dispose()
    {
        App.chain.onChangeAccount.removeHandler(this._refreshFunc);
        const sharexInf = App.Inst.getInst(ShareXInfrastructure);
        if (sharexInf) sharexInf.onRefresh.removeHandler(this._refreshFunc);
    }


    private _loadedSharexAdr="";
    private _items:com.CmpTableItemShareX[]=[];
    public async refreshAsync(anyway=false)
    {
        if (anyway) this._loadedSharexAdr="";
        const wallet = App.Inst.getInst(WalletControllerBase);
        if (!wallet) return;
        const sharexInf = App.Inst.getInst(ShareXInfrastructure);
        if (!sharexInf) return;

        if (App.chain.account)
            this.ctrls.btnConnect.hide();

        if (!sharexInf.selectedShareX)
        {
            this._loadedSharexAdr="";
            this.ctrls.list.html='';
            this._items=[];
            //хайдим все
            this.ctrls.blockList.hide();

            return;
        } else
        {
            const sharexAdr=sharexInf.selectedShareX.address;
            let owner = App.chain.account;
            if (!owner) owner = "0x0000000000000000000000000000000000000000";
            if (this._loadedSharexAdr==sharexAdr+owner) return;
            this._loadedSharexAdr = sharexAdr+owner;
            this.ctrls.list.html='';
            this._items=[];
            this._checkBtnsActive();

            this.ctrls.blockList.show();
            this.ctrls.btns.hide();
            if (App.chain.isConnected)
                this.ctrls.btns.show();

            const tokens = wallet.getTokens();
            this.ctrls.list.html='';

            const infoContract = new ShareXHelperContract(ShareXInfrastructure.ADDRESS_SHAREX_INFO, App.chain.provider);
            const infoResult = await infoContract.getInfo(sharexAdr,owner,tokens.map(t=>t.address));
            if (!infoResult) return;

            {
                let item = new com.CmpTableItemShareX();
                item.ctrls.lSymbol.text="PLS";
                item.ctrls.lToCalc.text=Web3Helper.ToLargeNumberUnit(infoResult.ethCalc_);
                item.ctrls.lToClaim.text=Web3Helper.ToLargeNumberUnit(infoResult.ethClaim_);
                item.onclick=()=>{item.activeFlip();this._checkBtnsActive();}
                this.ctrls.list.append(item);
                this._items.push(item);
            }
            for(let i=0;i<tokens.length;i++)
            {
                const token = tokens[i];
                const info = infoResult.info_[i];

                let item = new com.CmpTableItemShareX();
                item.ctrls.lSymbol.text=token.symbol;
                item.ctrls.lToCalc.text=Web3Helper.ToLargeNumberUnit(info.forCalc*sharexInf.getDecimalCorIndex(token.address)/BiMath.Decimal);
                item.ctrls.lToClaim.text=Web3Helper.ToLargeNumberUnit(info.forClaim*sharexInf.getDecimalCorIndex(token.address)/BiMath.Decimal);
                (item as any).token = token;
                item.onclick=()=>{item.activeFlip(); this._checkBtnsActive();}
                this.ctrls.list.append(item);
                this._items.push(item);
            }
        }
    }

    private _checkBtnsActive()
    {
        if (this._items.find(t=>t.isActive))
        {
            this.ctrls.btnClaim.enable();
            this.ctrls.btnCalc.enable();
        } else
        {
            this.ctrls.btnClaim.disable();
            this.ctrls.btnCalc.disable();
        }
    }

    private async _tryCalcAsync()
    {
        const sharexInf = App.Inst.getInst(ShareXInfrastructure);
        if (!sharexInf) return;
        if (!sharexInf.selectedShareX) return;
        const infoContract = new ShareXContract(sharexInf.selectedShareX.address, App.chain.provider);
        const stepTx0 = App.gui.getTxLockText();
        const list = this._items.filter(t=>t.isActive);
        if (list.length==0) return;
        let i=1;
        for(const item of list)
        {
            const token = (item as any).token as Token;
            if (!token)
            {
                let stepTx = 
                "Step "+i+" of "+list.length+"\n"+
                "'Pulse' is calculating.\n"+
                "Please wait - this may take a few minutes.\n";
                if (i<list.length) stepTx+= "Other transactions will start automatically.\n";
                App.gui.setTxLockText(stepTx);

                await infoContract.consumeIncomeETH();
            } else
            {
                let stepTx = 
                "Step "+i+" of "+list.length+"\n"+
                "'"+token.name+"' is calculating.\n"+
                "Please wait - this may take a few minutes.\n";
                if (i<list.length) stepTx+= "Other transactions will start automatically.\n";
                App.gui.setTxLockText(stepTx);
                await infoContract.consumeIncomeERC20(token.address);
            }
            i++;
        }
        App.gui.setTxLockText(stepTx0);
    }

    private async _tryClaimAsync()
    {
        const sharexInf = App.Inst.getInst(ShareXInfrastructure);
        if (!sharexInf) return;
        if (!sharexInf.selectedShareX) return;
        const infoContract = new ShareXContract(sharexInf.selectedShareX.address, App.chain.provider);
        const stepTx0 = App.gui.getTxLockText();
        const list = this._items.filter(t=>t.isActive);
        if (list.length==0) return;
        let i=1;
        for(const item of list)
        {
            const token = (item as any).token as Token;
            if (!token)
            {
                let stepTx = 
                "Step "+i+" of "+list.length+"\n"+
                "'Pulse' is claiming.\n"+
                "Please wait - this may take a few minutes.\n";
                if (i<list.length) stepTx+= "Other transactions will start automatically.\n";
                App.gui.setTxLockText(stepTx);

                await infoContract.withdrawETH();
            } else
            {
                let stepTx = 
                "Step "+i+" of "+list.length+"\n"+
                "'"+token.name+"' is claiming.\n"+
                "Please wait - this may take a few minutes.\n";
                if (i<list.length) stepTx+= "Other transactions will start automatically.\n";
                App.gui.setTxLockText(stepTx);
                await infoContract.withdrawERC20(token.address);
            }
            i++;
        }
        App.gui.setTxLockText(stepTx0);
    }
}